import { NgModule } from '@angular/core';
import { Route, RouterModule, Routes } from '@angular/router';

import { SharedModule } from '@app/shared';
import { AuthGuard } from '@app/core/auth';

import { PatientRequestsComponent } from './container/patient-requests.component';
import { PatientHistoryListComponent } from './history-list/patient-history-list.component';
import { PatientRequestListComponent } from './request-list/patient-request-list.component';
import { PatientRequestDetailComponent } from './request-detail/patient-request-detail.component';
import { AcumuladosTableViewComponent } from './acumulados-table-view/acumulados-table-view.component';
import { EvolutionChartsViewComponent } from './evolution-charts/evolution-charts-view.component';
import { ViewRequestComponent } from './view-request/view-request.component';
import { EpidemiologyTableViewComponent } from './epidemiology-table-view/epidemiology-table-view.component';
import { SensitivityATBViewComponent } from './sensitivity-atb-view/sensitivity-atb-view.component';
import { rbac } from '@app/shared/rbac';
import { CenterListComponent } from './components/centers/center-list/center-list.component';

const securedRoute: Route = {
  canActivate: [AuthGuard],
};

const routes: Routes = [
  {
    path: 'patient-requests',
    children: [
      {
        path: '',
        component: PatientRequestsComponent,
        canActivate: [AuthGuard],
        data: {
          profiles: [rbac.profiles.WEBRESULTS_USER],
        },
      },
      {
        path: 'histories',
        component: PatientHistoryListComponent,
        canActivate: [AuthGuard],
        data: {
          profiles: [rbac.profiles.WEBRESULTS_USER],
        },
      },
      {
        path: 'centers',
        component: CenterListComponent,
        canActivate: [AuthGuard],
        data: {
          roles: [rbac.roles.ADMIN],
        },
      },
      {
        path: 'patient/:id',
        component: PatientRequestListComponent,
        canActivate: [AuthGuard],
        data: {
          profiles: [rbac.profiles.WEBRESULTS_USER],
        },
      },
      {
        path: 'requests',
        component: PatientRequestListComponent,
        canActivate: [AuthGuard],
        data: {
          profiles: [rbac.profiles.WEBRESULTS_USER],
        },
      },
      {
        path: 'requests/:token',
        component: PatientRequestDetailComponent,
        canActivate: [AuthGuard],
        data: {
          profiles: [rbac.profiles.WEBRESULTS_USER],
        },
      },
      {
        path: 'acumulados-view',
        component: AcumuladosTableViewComponent,
        canActivate: [AuthGuard],
        data: {
          profiles: [rbac.profiles.WEBRESULTS_USER],
          hideMenu: true,
        },
      },
      {
        path: 'evolution-charts',
        component: EvolutionChartsViewComponent,
        canActivate: [AuthGuard],
        data: {
          profiles: [rbac.profiles.WEBRESULTS_USER],
          hideMenu: true,
        },
      },
      {
        path: 'view-request',
        component: ViewRequestComponent,
        canActivate: [AuthGuard],
        data: {
          profiles: [rbac.profiles.WEBRESULTS_USER],
          hideMenu: true,
        },
      },
      {
        path: 'epidemiology-view',
        component: EpidemiologyTableViewComponent,
        canActivate: [AuthGuard],
        data: {
          profiles: [rbac.profiles.WEBRESULTS_USER],
          hideMenu: true,
        },
      },
      {
        path: 'sensitivity-atb-view',
        component: SensitivityATBViewComponent,
        canActivate: [AuthGuard],
        data: {
          profiles: [rbac.profiles.WEBRESULTS_USER],
          hideMenu: true,
        },
      },
    ],
  },
];

@NgModule({
  imports: [SharedModule, RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PatientRequestsRoutingModule {}
